import Button from "../views/components/Button";
import SwitchButton from "../views/components/SwitchButton";
import { UIStates, UIModes } from "./UIStates";
import { UIBehaviourPattern, IBehaviourPattern } from "./UIBehaviour";
import InterractionManager from "./InteractionManager";
import { Commands } from "../commands/CommandEnum";
import PointerEvents from "../../src/const/PointerEvents";
import InstanceFactory from "../../src/factories/InstanceFactory";
import SceneView from "../views/SceneView";
import BaseView from "../views/BaseView";
import Comm from "../controllers/BaseComm";
import { UIUpdateEvent } from "./UIUpdateEvents";
import { Sprite } from "pixi.js";
import ConsoleUtil from "../utils/ConsoleUtil";

export default abstract class BaseUI {
    protected elements: BaseView[];
    protected hidden: boolean = false;
    protected buttons: BaseView[];
    protected behaviourMapMaster: Map<
        string | UIModes,
        Map<string | UIStates, UIBehaviourPattern>
    >;
    // protected behaviourMap: Map< string | UIStates, UIBehaviourPattern>;
    protected interractionManager: InterractionManager;
    protected scene: SceneView;

    constructor() {
        // this.behaviourMap = new Map< string | UIStates, UIBehaviourPattern>();
        this.behaviourMapMaster = new Map<
            string | UIModes,
            Map<string | UIStates, UIBehaviourPattern>
        >();
        this.elements = [];
        this.buttons = [];
    }

    public get isHidden(): boolean {
        return this.hidden;
    }

    public create(): void {
        this.interractionManager = InstanceFactory.getClass(
            "InterractionManager"
        );
    }

    abstract update(events?: UIUpdateEvent, props?: any): void;

    /**
     * This method will be called two times:
     * 
     * 1. when the game resources has been loaded (initial will be set to true).
     * 2. when the mobile device has been rotated for first time (initial will be set to false).
     * 
     * Usage example: PageSettings (which overrides this method) are preInitialized
     * and then most of the settings scenes are pooled (will be reused).
     * 
     * This way, when the user opens the settings menu, s/he won't wait anything,
     * because all the computations will be already done.
     *
     * @memberof BaseUI
     */
    public preInitialize(initial: boolean): void {

    }

    public setState(
        state: UIStates | string,
        mode: UIModes | string = UIModes.DEFAULT
    ) {
        let behaviourMap: Map<string | UIStates, UIBehaviourPattern>;
        if (this.behaviourMapMaster.has(mode)) {
            behaviourMap = this.behaviourMapMaster.get(mode);
            // if (this.behaviourMap.has(state)) {
            //     this.behaviourMap.get(state).executePattern();
            // }
        } else if (this.behaviourMapMaster.has(UIModes.DEFAULT)) {
            behaviourMap = this.behaviourMapMaster.get(UIModes.DEFAULT);
        }

        if (behaviourMap && behaviourMap.has(state)) {
            behaviourMap.get(state).executePattern();
        } else if (behaviourMap && behaviourMap.has(UIStates.DEFAULT)) {
            behaviourMap.get(UIStates.DEFAULT).executePattern();
        }
        this.update();
    }

    protected warnForMissingElement(elementName: string) {
        ConsoleUtil.warn("[UI] MISSING UI ELEMENT -> " + elementName);
    }

    protected setBehaviour(
        state: UIStates | string,
        pattern: IBehaviourPattern,
        mode: UIModes | string = UIModes.DEFAULT
    ) {
        if (!this.behaviourMapMaster.has(mode)) {
            this.behaviourMapMaster.set(
                mode,
                new Map<string | UIStates, UIBehaviourPattern>()
            );
        }
        // this.behaviourMap.set(state, new UIBehaviourPattern(pattern));
        this.behaviourMapMaster
            .get(mode)
            .set(state, new UIBehaviourPattern(pattern));
    }

    protected assignInterraction(
        action: Commands | Commands[] | string | string[],
        element: Button | BaseView | Sprite,
        sound?: string | string[],
        args?: any,
        triggerEvent?: PointerEvents
    ) {
        if (element) {
            if (!(element instanceof Button)) {
                element.interactive = true;
            }
            this.interractionManager.assign(
                action,
                element,
                args,
                triggerEvent
            );
            if (Array.isArray(sound)) {
                (element as SwitchButton).setSound(sound[0], sound[1]);
            } else if (element instanceof Button) {
                element.setSound(sound);
            }
        }
    }

    protected unassignInteraction(element: Button) {
        this.interractionManager.unAssign(element);
    }

    protected clearInteractions() {
        if (this.interractionManager) {
            this.interractionManager.clear();
        }
    }
}
